export const muiConfig = {
    typography: {
        fontFamily: 'Inter, sans-serif',
    }
}